<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
              class="content-nav-btn"
              :class="{'content-nav-active':newstype == 1}"
              @click="newstype = 1"
          >
            <span>公司新闻</span>
          </div>
          <div
              class="content-nav-btn"
              :class="{'content-nav-active':newstype == 2}"
              @click="newstype = 2 "
          >
            <span>热门推荐</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.informationId }}"
            >
              <div class="item-img" v-lazy:background-image="item.informationCoverList[0]"></div>
              <p class="item-list-title">{{item.informationTitle}}</p>
              <div class="item-list-more">
                <img src="../assets/img/sanjiao.png" />
                <span>more</span>
              </div>
            </router-link>
          </div>
        </div>

        <div class="page-box">
          <el-pagination
              background
              layout="prev, pager, next"
              @current-change ="changePage"
              @prev-click = "changePage"
              @next-click = "changePage"
              :page-count="pageCount" v-show="newstype == 1">
          </el-pagination>

          <el-pagination
              background
              layout="prev, pager, next"
              @current-change ="changePage"
              @prev-click = "changePage"
              @next-click = "changePage"
              :page-count="pageCount" v-show="newstype == 2">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1,
      formData: {
        page: 1,
        limit: 6,
        classifyId: "",
      },
      pageCount: 0,
      options: {},
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      if(this.newstype == 2) {
        this.formData.classifyId =3;
      }else {
        this.formData.classifyId = "";
      }
      this.$http
          .post(`https://www.tgr39.com/mall-base/baseInformationInfo/userQueryInformationInfoById`, this.formData, this.options)
          .then(response => {
            let resData = response.data.data;
            this.newsList = resData.list || [];
            this.pageCount = resData.totalPage;
            this.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
          });
    },
    changePage(e) {
      this.formData.page = e;
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype(type) {
      this.formData.page = 1;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.page-box{
  padding: 20px;
  text-align: right;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        position: relative;
        bottom: 30px;
        box-shadow: 0 0 5px 2px #f5f5f5;
        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ffffff;
          transition: all 0.2s;
        }
        .content-nav-active {
          background-color: #48a83c;
          color: #fff;
        }
      }
      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .item-list {
          width: 330px;
          padding: 0 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #48a83c;
          border-radius: 6px;
          cursor: pointer;
          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #f5f5f5;
          }
          .item-img {
            width: 330px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }
          &-title {
            width: 300px;
            height: 60px;
            color: #48a83c;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #48a83c;
          }
          &-more {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}

@media screen and (max-width: 1240px) {
  .news .news-section .news-section-content {
    width: 100%;
    padding: 0 15px;
  }
  .news .news-section .news-section-content .content-nav-item {
    width: 100%;
  }
}
@media screen and (max-width: 992px) {
  .news .news-section .news-section-content .content-nav {
    width: 320px;
    height: 48px;
    bottom: 20px;
  }
  .news .news-section .news-section-content .content-nav-item .item-list {
    width: 46%;
    margin: 8px 2%;
  }
  .news .news-section .news-section-content .content-nav-item .item-list .item-img {
    width: 100%;
    height: 180px;
  }
  .news .news-section .news-section-content .content-nav-item .item-list .item-list-title {
    width: 90%;
    font-size: 18px;
    height: auto;
    min-height: 50px;
  }
}
@media screen and (max-width: 640px) {
  .news .news-section .news-section-content .content-nav {
    width: 260px;
  }
  .news .news-section .news-section-content .content-nav-item .item-list {
    width: 96%;
    margin: 10px 2%;
  }
  .page-box {
    padding: 15px 0;
    text-align: center;
    ::v-deep .el-pagination {
      button,
      .el-pager li {
        min-width: 28px !important;
        height: 28px !important;
        font-size: 12px;
        margin: 0 1px !important;
        padding: 0 !important;
      }
      .el-pagination__jump {
        display: none !important;
      }
    }
  }
}
</style>